import { useState, useCallback } from 'react';
import { adminService } from '../services';

/**
 * Hook personalizado para manejar estadísticas de reservas de eventos
 */
export const useEventStats = () => {
  const [stats, setStats] = useState({
    soldTickets: 0,
    availableTickets: 0,
    reservedTickets: 0,
    totalTickets: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Función para cargar estadísticas de un evento
  const loadEventStats = useCallback(async (eventId) => {
    if (!eventId) return;

    setLoading(true);
    setError(null);

    try {
      // Obtener estadísticas del evento
      const statsData = await adminService.getEventReservationStats(eventId);
      
      // Usar estadísticas efectivas (considerando capacidad de palcos) si están disponibles
      // Fallback a estadísticas por reservas si no están disponibles
      const soldTickets = statsData.soldEffectiveSeats || statsData.soldReservations || 0;
      const reservedTickets = statsData.pendingEffectiveSeats || statsData.pendingReservations || 0;
      const blockedTickets = statsData.blockedEffectiveSeats || statsData.blockedReservations || 0;
      const totalTickets = 1061+104; // Valor fijo por ahora, debería venir del evento (+ palcos 26x4)
      const availableTickets = totalTickets - soldTickets - reservedTickets;

      setStats({
        soldTickets,
        availableTickets: Math.max(0, availableTickets),
        reservedTickets: Math.max(0, reservedTickets),
        blockedTickets: Math.max(0, blockedTickets),
        totalTickets,
        // Información adicional sobre capacidad de palcos
        palcoCapacity: statsData.palcoCapacity || 4
      });
    } catch (err) {
      setError(err.message || 'Error al cargar estadísticas del evento');
      console.error('Error en useEventStats:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Función para refrescar estadísticas
  const refreshStats = useCallback((eventId) => {
    loadEventStats(eventId);
  }, [loadEventStats]);

  return {
    stats,
    loading,
    error,
    loadEventStats,
    refreshStats
  };
};

export default useEventStats; 